import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { WaitingListItem } from '../hooks/common';

interface WaitingListState {
  waitingList: WaitingListItem[];
  lastFetch: number;

  // Actions
  setWaitingList: (items: WaitingListItem[]) => void;
  addItem: (item: WaitingListItem) => void;
  updateItem: (id: string, updates: Partial<WaitingListItem>) => void;
  removeItem: (id: string) => void;
  clearWaitingList: () => void;
  isStale: () => boolean;
  markAsStale: () => void;
}

const STALE_TIME = 5 * 60 * 1000; // 5 minutos

export const useWaitingListStore = create<WaitingListState>()(
  persist(
    (set, get) => ({
      waitingList: [],
      lastFetch: 0,

      setWaitingList: (items) => {
        set({
          waitingList: items,
          lastFetch: Date.now(),
        });
      },

      addItem: (item) => {
        const newList = [...get().waitingList, item];
        set({
          waitingList: newList,
          lastFetch: Date.now(),
        });
      },

      updateItem: (id, updates) => {
        set({
          waitingList: get().waitingList.map((item) =>
            item.id === id ? { ...item, ...updates } : item
          ),
          lastFetch: Date.now(),
        });
      },

      removeItem: (id) => {
        const newList = get().waitingList.filter((item) => item.id !== id);
        set({
          waitingList: newList,
          lastFetch: Date.now(),
        });
      },

      clearWaitingList: () => {
        set({
          waitingList: [],
          lastFetch: 0,
        });
      },

      isStale: () => {
        const now = Date.now();
        const lastFetch = get().lastFetch;
        return now - lastFetch > STALE_TIME;
      },

      markAsStale: () => {
        set({ lastFetch: 0 });
      },
    }),
    {
      name: 'waiting-list-storage',
      version: 1,
    }
  )
);
